import script from "./CheckTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckTable.vue?vue&type=script&setup=true&lang=js"

import "./CheckTable.vue?vue&type=style&index=0&id=6db43a5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6db43a5a"]])

export default __exports__